var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit.5 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25093 13.352L12.1085 5.77703C12.4269 5.36855 12.5401 4.89627 12.4339 4.4154C12.342 3.97825 12.0731 3.56259 11.6699 3.24727L10.6866 2.46612C9.8306 1.7853 8.7694 1.85697 8.161 2.63811L7.50307 3.49164C7.4182 3.59842 7.4394 3.75609 7.54553 3.84208C7.54553 3.84208 9.208 5.17505 9.2434 5.20372C9.3566 5.31122 9.44147 5.45454 9.46273 5.62654C9.49807 5.96336 9.2646 6.27869 8.918 6.32169C8.75527 6.34319 8.5996 6.29302 8.48647 6.19986L6.73907 4.80956C6.65417 4.74577 6.52683 4.75939 6.45609 4.84539L2.30343 10.2203C2.0346 10.5571 1.94263 10.9943 2.0346 11.4171L2.56518 13.7175C2.59347 13.8393 2.69959 13.9253 2.82693 13.9253L5.16148 13.8967C5.58594 13.8895 5.98211 13.696 6.25093 13.352ZM9.5198 12.6356H13.3265C13.6979 12.6356 14 12.9416 14 13.3178C14 13.6948 13.6979 14.0001 13.3265 14.0001H9.5198C9.1484 14.0001 8.84633 13.6948 8.84633 13.3178C8.84633 12.9416 9.1484 12.6356 9.5198 12.6356Z",
    fill: "#A2A2A2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1d15b91f6026ba97d6514ce87dd4b160.svg";
export { ForwardRef as ReactComponent };